import { SlicePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatListModule, MatSelectionList } from '@angular/material/list';
import { Attachment } from 'src/app/models/server/attachment';
import { AvmFileSizePipe } from '../../../core/pipes/avm-file-size.pipe';
import { DialogSelectFolderFilesData } from './models/dialog-select-folder-files-data';

@Component({
    selector: 'app-select-folder-files',
    templateUrl: './select-folder-files.component.html',
    styleUrls: ['./select-folder-files.component.scss'],
    imports: [MatCardModule, MatListModule, MatButtonModule, SlicePipe, AvmFileSizePipe]
})
export class SelectFolderFilesComponent implements OnInit {
    /**
     * Liste des fichiers d'un dossier.
     */
    public folderFiles: Attachment[];

    /**
     * Liste des fichiers sélectionnés
     */
    public selectedFolderFiles: Attachment[];

    constructor(
        public dialogRef: MatDialogRef<SelectFolderFilesComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogSelectFolderFilesData
    ) {}

    ngOnInit(): void {
        this.folderFiles = this.data.attachments.sort((a, b) => a.name.localeCompare(b.name));
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }

    public valid(selectedFiles: MatSelectionList) {
        this.selectedFolderFiles = this.folderFiles.filter((a) => selectedFiles.selectedOptions.selected.find((b) => b.value === a.id));
        this.dialogRef.close(this.selectedFolderFiles);
    }
}
